import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@core';
import { KebabMenuComponent } from 'app/shared/components/kebab-menu/kebab-menu/kebab-menu.component';

@Component({
    selector: 'app-page-header',
    imports: [KebabMenuComponent],
    templateUrl: './page-header.component.html',
    styleUrl: './page-header.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageHeaderComponent {
    private authService = inject(AuthService);
    private router = inject(Router);
    public headline = input.required<string>();
    public headlineId = input<string>();

    protected menuItems = [
        {
            label: 'Dashboard',
            icon: 'home',
            route: ['/', 'portal', 'dashboard'],
        },
        {
            label: 'Mein Kundenkonto',
            icon: 'person',
            route: ['/', 'portal', 'mein-kundenkonto'],
        },
        {
            label: 'Schaden melden',
            icon: 'damage',
            route: ['/', 'portal', 'schaden-melden'],
        },
        {
            label: 'Bezahlmethode',
            icon: 'credit_card',
            route: ['/', 'portal', 'vertrag-waehlen-fuer-bezahlmethoden'],
        },
        {
            label: 'Abmelden',
            icon: 'logout',
            action: (): void => {
                this.authService.logout();
                this.router.navigate(['/login']);
            },
        },
    ];
}
